var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBackArrowSimple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 18L22.5 6.75L24.075 8.325L14.4 18L24.075 27.675L22.5 29.25L11.25 18Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBackArrowSimple);
export default __webpack_public_path__ + "static/media/ic-back-arrow-simple.fe98572d4872031c53c71a9d7cd28990.svg";
export { ForwardRef as ReactComponent };